/**
 * Two Column Feature — "Animated Icons" layout
 *
 * Each card's video plays while the pointer is anywhere over the card and
 * pauses (resetting to the first frame) on leave. The card itself is NOT a
 * link — only its button is — so hover is the sole trigger.
 *
 * :focus-within is included so keyboard users tabbing to the card's button get
 * the same playback.
 */

var REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

function initCard(card) {
    var video = card.querySelector('.tcf-col-video');

    if (!video) {
        return;
    }

    // Respect reduced-motion: leave the video paused on its first frame.
    if (window.matchMedia(REDUCED_MOTION).matches) {
        return;
    }

    var play = function () {
        // play() returns a promise that rejects if interrupted (e.g. the
        // pointer leaves before playback starts). Swallow it — the pause
        // handler has already done the right thing.
        var attempt = video.play();

        if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(function () {});
        }
    };

    var stop = function () {
        video.pause();
        video.currentTime = 0;
    };

    card.addEventListener('mouseenter', play);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusin', play);
    card.addEventListener('focusout', function (event) {
        // Only stop once focus has left the card entirely.
        if (!card.contains(event.relatedTarget)) {
            stop();
        }
    });
}

function initTwoColumnFeature() {
    document.querySelectorAll('.two-column-feature.animated_icons .tcf-col').forEach(initCard);
}

document.addEventListener('DOMContentLoaded', initTwoColumnFeature);

export { initTwoColumnFeature };
